module.exports = __webpack_public_path__ + "3a106a7a63feb89c36e516790479ef90.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/covers/cover_11.jpg
 ** module id = 593
 ** module chunks = 0
 **/